export enum FloatingTicketActionTypes {
  CLAIM_REQUEST = 'floating-ticket/FETCH_REQUEST',
  CLAIM_ERROR = 'floating-ticket/FETCH_ERROR',
  CLAIM_SUCCESS = 'floating-ticket/FETCH_SUCCESS',
}
